import Image from "next/image";
import { FC } from "react";

import { ImageAmenityColumn, LayoutType } from "./type";

interface CardTabImageProp {
  column: ImageAmenityColumn;
}

const CardTabImage: FC<CardTabImageProp> = ({ column }) => {
  return (
    <>
      <div className={`h-full flex flex-col items-center ${column.layout === LayoutType.HORIZONTAL ? "aspect-4-3 w-fix-tab-card" : "aspect-3-4"}`}>
        <Image
          className="object-cover w-full h-full rounded-xl"
          src={column.image.url}
          alt={column.image.title}
          width={`${column.layout === "vertical" ? "343" : "457"}`}
          height={`${column.layout === "vertical" ? "457" : "343"}`}
        />
      </div>
    </>
  );
};
export default CardTabImage;
